import type { BlockEditFormState } from '@ContractBuilder/modules/block-edit';
import { isClauseBlock } from '@root/helpers/blocks';
import { isEmpty, pick, values } from 'lodash-es';

const DETAILS_SECTION_FIELDS = [
  'class_of_business',
  'classification',
  'clause_reference',
  'clause_type',
  'expiry_date',
  'inception_date',
  'parentBlockId',
  'teams',
] as const satisfies ReadonlyArray<keyof BlockEditFormState>;

export const getHideSection = (isAdminView: boolean, formValues?: BlockEditFormState): boolean => {
  if (isAdminView || (formValues && isClauseBlock(formValues))) {
    return false;
  }

  const nonEmptyValues = values(pick(formValues, DETAILS_SECTION_FIELDS)).filter((value) => !isEmpty(value));

  return nonEmptyValues.length === 0;
};
